import { render, staticRenderFns } from "./ItirazinIptaliDavasiForm.vue?vue&type=template&id=16750ca8"
import script from "./ItirazinIptaliDavasiForm.vue?vue&type=script&lang=ts"
export * from "./ItirazinIptaliDavasiForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports